import React, { useEffect, useRef, useState } from "react";
import { downloadReportPdf } from "../../../../services/reportsAnalyticsService";

// ── Icons ─────────────────────────────────────────────────────────────────────

const CustomizeIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    <path d="M15 5l3 3" />
  </svg>
);

const CloseModalIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const SwapArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#98A2B3"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);

// ── Customize Modal ───────────────────────────────────────────────────────────

const CUSTOMIZE_TABS = ["Customization Templates", "My Templates", "Archive"];

const TEMPLATE_CARDS = [
  {
    id: "demographic",
    title: "Demographic Reports",
    desc: "Demographic groups are most important to your business",
    iconLeft: {
      bg: "#7F56D9",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>
      ),
    },
    iconRight: {
      bg: "#F97066",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>
      ),
    },
  },
  {
    id: "impressions",
    title: "Impressions Report",
    desc: "To help you see which campaigns are of more interest",
    iconLeft: {
      bg: "#7F56D9",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ),
    },
    iconRight: {
      bg: "#36BFFA",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ),
    },
  },
  {
    id: "clicks",
    title: "Clicks Reports",
    desc: "See what reports are getting the most clicks",
    iconLeft: {
      bg: "#7F56D9",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32" />
        </svg>
      ),
    },
    iconRight: {
      bg: "#F97066",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 3l14 9-14 9V3z" />
        </svg>
      ),
    },
  },
  {
    id: "compare-source",
    title: "Compare Source",
    desc: "Create reports comparing different",
    iconLeft: {
      bg: "#1877F2",
      content: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
        </svg>
      ),
    },
    iconRight: {
      bg: "linear-gradient(135deg, #833AB4, #FD1D1D, #F77737)",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeWidth="3" />
        </svg>
      ),
    },
  },
  {
    id: "program-comparison",
    title: "Program Comparison",
    desc: "Compare which programs are getting traction",
    iconLeft: {
      bg: "#12B76A",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 8 12 12 14 14" />
        </svg>
      ),
    },
    iconRight: {
      bg: "#6172F3",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      ),
    },
  },
  {
    id: "applications-enrollments",
    title: "Applications & Enrollments Reports",
    desc: "Compare which campaigns are getting applications & enrollments",
    iconLeft: {
      bg: "#7F56D9",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
    },
    iconRight: {
      bg: "#F97066",
      content: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>
      ),
    },
  },
];

const CustomizeModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState(CUSTOMIZE_TABS[0]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(16,24,40,0.45)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          width: "100%",
          maxWidth: 680,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 24px 64px rgba(16,24,40,0.2)",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 24px 16px",
            borderBottom: "1px solid #F2F4F7",
          }}
        >
          <span style={{ fontSize: "1rem", fontWeight: 500, color: "#302843" }}>
            Customization of your own report
          </span>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#667085",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 4,
              borderRadius: 6,
            }}
          >
            <CloseModalIcon />
          </button>
        </div>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            gap: 4,
            padding: "16px 24px 0",
          }}
        >
          {CUSTOMIZE_TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                background: activeTab === tab ? "#F4EBFF" : "transparent",
                color: activeTab === tab ? "#6941C6" : "#667085",
                border: "none",
                borderRadius: 5,
                padding: "5px 14px",
                fontSize: "0.8rem",
                fontWeight: activeTab === tab ? 600 : 400,
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Cards Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 16,
            padding: "20px 24px 24px",
          }}
        >
          {TEMPLATE_CARDS.map((card) => (
            <div
              key={card.id}
              style={{
                border: "1px solid #E4E7EC",
                borderRadius: 12,
                background: "#fff",
                overflow: "hidden",
                cursor: "not-allowed",
                padding: "16px",
                opacity: 1,
              }}
            >
              {/* Icon preview area — dimmed */}
              <div
                style={{
                  background: "#F2F4F7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  borderRadius: 12,
                  padding: "24px 16px",
                  opacity: 0.55,
                  filter: "grayscale(0.4)",
                }}
              >
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    background: card.iconLeft.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {card.iconLeft.content}
                </div>
                <SwapArrowIcon />
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    background: card.iconRight.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {card.iconRight.content}
                </div>
              </div>

              {/* Text area — dimmed */}
              <div style={{ paddingTop: "14px" }}>
                <div
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: 600,
                    color: "#667085",
                    marginBottom: 6,
                    lineHeight: 1.4,
                  }}
                >
                  {card.title}
                </div>
                <div
                  style={{
                    fontSize: "0.78rem",
                    color: "#98A2B3",
                    lineHeight: 1.5,
                  }}
                >
                  {card.desc}
                </div>

                {/* Coming Soon badge — full color */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 10,
                  }}
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "#F4EBFF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <svg width="11" height="11" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M10 2L12.09 7.26L18 8.27L14 12.14L14.91 18L10 15.27L5.09 18L6 12.14L2 8.27L7.91 7.26L10 2Z"
                        fill="#9E77ED"
                      />
                    </svg>
                  </div>
                  <span
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: "#7F56D9",
                    }}
                  >
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const CalendarGridIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="8" y1="14" x2="8" y2="14" strokeWidth="2.5" />
    <line x1="12" y1="14" x2="12" y2="14" strokeWidth="2.5" />
    <line x1="16" y1="14" x2="16" y2="14" strokeWidth="2.5" />
    <line x1="8" y1="18" x2="8" y2="18" strokeWidth="2.5" />
    <line x1="12" y1="18" x2="12" y2="18" strokeWidth="2.5" />
  </svg>
);

const ExportIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="8 17 12 21 16 17" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29" />
  </svg>
);

const CloseIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// ── Constants ─────────────────────────────────────────────────────────────────

// ── Quick filters commented out (to be re-enabled later) ──
// const PRESET_FILTERS = [
//   { label: "1 Month",  type: "1months" },
//   { label: "3 Months", type: "3months" },
//   { label: "6 Months", type: "6months" },
//   { label: "1 Year",   type: "year"    },
// ];

const getActiveLabel = (filter) => {
  if (!filter || filter.type === "default") return null;
  // ── Preset label lookup commented out ──
  // const preset = PRESET_FILTERS.find((p) => p.type === filter.type);
  // if (preset) return preset.label;
  if (filter.type === "custom")
    return `${filter.startDate} → ${filter.endDate}`;
  return null;
};

// ── Component ─────────────────────────────────────────────────────────────────

/**
 * Reports & Analytics header with a date-range filter and Export PDF button.
 *
 * @param {string}   [title]
 * @param {{ type: string, startDate?: string, endDate?: string }} [activeFilter]
 * @param {Function} [onFilterChange]  Called with the new filter object
 */
const ReportsHeader = ({
  title = "Reports \u0026 Analytics",
  activeFilter = { type: "default" },
  onFilterChange,
  clientId,
}) => {
  const [open, setOpen] = useState(false);
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [customizeOpen, setCustomizeOpen] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const wrapperRef = useRef(null);

  const handleExportPdf = async () => {
    if (!clientId || pdfLoading) return;
    setPdfLoading(true);
    try {
      const { blob, filename } = await downloadReportPdf(clientId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export PDF failed:", err?.message);
    } finally {
      setPdfLoading(false);
    }
  };

  // Populate inputs when filter is already set to custom
  useEffect(() => {
    if (activeFilter?.type === "custom") {
      setCustomStart(activeFilter.startDate ?? "");
      setCustomEnd(activeFilter.endDate ?? "");
    }
  }, [activeFilter]);

  // Close dropdown on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleApplyCustom = () => {
    if (!customStart || !customEnd) return;
    onFilterChange?.({
      type: "custom",
      startDate: customStart,
      endDate: customEnd,
    });
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onFilterChange?.({ type: "default" });
    setCustomStart("");
    setCustomEnd("");
    setOpen(false);
  };

  const activeLabel = getActiveLabel(activeFilter);
  const isActive = !!activeLabel;
  const canApply = customStart && customEnd && customEnd >= customStart;

  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h5
          className="mb-0 fw-bold"
          style={{ color: "#fff", fontSize: "1.25rem" }}
        >
          {title}
        </h5>

        {/* ── Right-side actions ── */}
        <div className="d-flex align-items-center gap-2">
          {/* ── Date filter trigger ── */}
          <div ref={wrapperRef} style={{ position: "relative" }}>
            <button
              onClick={() => setOpen((o) => !o)}
              className="d-flex align-items-center gap-2"
              style={{
                padding: "8px 16px",
                borderRadius: 24,
                border: isActive
                  ? "1.5px solid #9E77ED"
                  : "1.5px solid rgba(255,255,255,0.25)",
                background: isActive
                  ? "linear-gradient(135deg, #F9F5FF 0%, #EDE9FE 100%)"
                  : "rgba(255,255,255,0.08)",
                color: isActive ? "#6941C6" : "#fff",
                fontSize: "0.82rem",
                fontWeight: isActive ? 600 : 500,
                cursor: "pointer",
                boxShadow: isActive
                  ? "0 0 0 3px rgba(159,119,237,0.15)"
                  : "none",
                transition: "all 0.2s",
                whiteSpace: "nowrap",
              }}
            >
              <CalendarGridIcon />
              <span>{isActive ? activeLabel : "Select dates"}</span>
              {isActive && (
                <span
                  onClick={handleClear}
                  title="Clear filter"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    background: "#9E77ED",
                    color: "#fff",
                    cursor: "pointer",
                    flexShrink: 0,
                    marginLeft: 2,
                  }}
                >
                  <CloseIcon />
                </span>
              )}
            </button>

            {/* ── Dropdown panel ── */}
            {open && (
              <div
                style={{
                  position: "absolute",
                  top: "calc(100% + 8px)",
                  right: 0,
                  width: 300,
                  background: "#fff",
                  border: "1px solid #E4E7EC",
                  borderRadius: 14,
                  boxShadow: "0 12px 40px rgba(16,24,40,0.14)",
                  zIndex: 1050,
                  overflow: "hidden",
                }}
              >
                {/* Panel header */}
                <div
                  style={{
                    padding: "13px 16px 12px",
                    borderBottom: "1px solid #F2F4F7",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <span
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      background: "linear-gradient(135deg, #7F56D9, #9E77ED)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      color: "#fff",
                    }}
                  >
                    <CalendarGridIcon />
                  </span>
                  <div>
                    <div
                      style={{
                        fontSize: "0.82rem",
                        fontWeight: 700,
                        color: "#101828",
                        lineHeight: 1.2,
                      }}
                    >
                      Select Date Range
                    </div>
                    <div style={{ fontSize: "0.7rem", color: "#667085" }}>
                      Filter analytics by date
                    </div>
                  </div>
                </div>

                {/* ── Quick Filters commented out ── */}
                {/* <div style={{ padding: "14px 16px 10px" }}>
                <div style={{ fontSize: "0.68rem", fontWeight: 700, color: "#9E77ED", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
                  Quick Filters
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  {PRESET_FILTERS.map(({ label, type }) => {
                    const isSelected = activeFilter?.type === type;
                    return (
                      <button key={type} onClick={() => { onFilterChange?.({ type }); setOpen(false); }}
                        style={{ padding: "9px 12px", borderRadius: 10, border: `1.5px solid ${isSelected ? "#7F56D9" : "#E4E7EC"}`, background: isSelected ? "linear-gradient(135deg, #F9F5FF, #EDE9FE)" : "#FAFAFA", color: isSelected ? "#6941C6" : "#344054", fontSize: "0.78rem", fontWeight: isSelected ? 700 : 500, cursor: "pointer" }}>
                        {label}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div style={{ margin: "0 16px", borderTop: "1px dashed #E4E7EC" }} /> */}

                {/* Custom Date Range */}
                <div style={{ padding: "14px 16px 16px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                      marginBottom: 12,
                    }}
                  >
                    <div>
                      <label
                        style={{
                          fontSize: "0.7rem",
                          color: "#667085",
                          fontWeight: 500,
                          display: "block",
                          marginBottom: 4,
                        }}
                      >
                        Start Date
                      </label>
                      <input
                        type="date"
                        value={customStart}
                        onChange={(e) => setCustomStart(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 10px",
                          border: "1.5px solid #D0D5DD",
                          borderRadius: 8,
                          fontSize: "0.78rem",
                          color: "#101828",
                          outline: "none",
                          background: "#FAFAFA",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        style={{
                          fontSize: "0.7rem",
                          color: "#667085",
                          fontWeight: 500,
                          display: "block",
                          marginBottom: 4,
                        }}
                      >
                        End Date
                      </label>
                      <input
                        type="date"
                        value={customEnd}
                        min={customStart || undefined}
                        onChange={(e) => setCustomEnd(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 10px",
                          border: "1.5px solid #D0D5DD",
                          borderRadius: 8,
                          fontSize: "0.78rem",
                          color: "#101828",
                          outline: "none",
                          background: "#FAFAFA",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  </div>
                  <button
                    onClick={handleApplyCustom}
                    disabled={!canApply}
                    style={{
                      width: "100%",
                      padding: "9px 0",
                      borderRadius: 9,
                      border: "none",
                      background: canApply
                        ? "linear-gradient(135deg, #7F56D9 0%, #9E77ED 100%)"
                        : "#F2F4F7",
                      color: canApply ? "#fff" : "#98A2B3",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      cursor: canApply ? "pointer" : "not-allowed",
                      transition: "all 0.15s",
                      boxShadow: canApply
                        ? "0 2px 8px rgba(127,86,217,0.3)"
                        : "none",
                    }}
                  >
                    Apply Date Range
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ── Customize button ── */}
          <button
            onClick={() => setCustomizeOpen(true)}
            className="d-flex align-items-center gap-2"
            style={{
              padding: "8px 16px",
              borderRadius: 24,
              border: "1.5px solid rgba(255,255,255,0.25)",
              background: "rgba(255,255,255,0.08)",
              color: "#fff",
              fontSize: "0.82rem",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.2s",
              whiteSpace: "nowrap",
            }}
          >
            <CustomizeIcon />
            <span>Customize</span>
          </button>

          {/* ── Export PDF button ── */}
          <button
            onClick={handleExportPdf}
            disabled={pdfLoading || !clientId}
            className="d-flex align-items-center gap-2"
            style={{
              padding: "8px 18px",
              borderRadius: 24,
              border: "none",
              background:
                pdfLoading || !clientId
                  ? "rgba(127,86,217,0.5)"
                  : "linear-gradient(135deg, #7F56D9 0%, #9E77ED 100%)",
              color: "#fff",
              fontSize: "0.82rem",
              fontWeight: 600,
              cursor: pdfLoading || !clientId ? "not-allowed" : "pointer",
              boxShadow:
                pdfLoading || !clientId
                  ? "none"
                  : "0 2px 10px rgba(127,86,217,0.4)",
              transition: "all 0.2s",
              whiteSpace: "nowrap",
              opacity: pdfLoading ? 0.75 : 1,
            }}
          >
            {pdfLoading ? (
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ animation: "spin 0.8s linear infinite" }}
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
            ) : (
              <ExportIcon />
            )}
            <span>{pdfLoading ? "Exporting..." : "Export PDF"}</span>
          </button>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>

      <CustomizeModal
        open={customizeOpen}
        onClose={() => setCustomizeOpen(false)}
      />
    </>
  );
};

export default ReportsHeader;
